import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  PutV1ProfilesByProfileIdData,
  PutV1ProfilesByProfileIdError,
  PutV1ProfilesByProfileIdResponse,
} from "../../client";
import { putV1ProfilesByProfileIdMutation } from "../../client/@tanstack/react-query.gen";
import { getOneProfileQueryKey } from "./get-one-profile";
import type { Options } from "@hey-api/client-fetch";

const mutationKey = ["updateProfile"];

export const useUpdateProfile = (profileId: string) => {
  const queryClient = useQueryClient();

  return useMutation<
    PutV1ProfilesByProfileIdResponse,
    PutV1ProfilesByProfileIdError,
    Options<PutV1ProfilesByProfileIdData>
  >({
    ...putV1ProfilesByProfileIdMutation(),
    mutationKey,
    onSuccess: async (response, variables) => {
      await queryClient.invalidateQueries({
        queryKey: getOneProfileQueryKey(profileId),
        exact: true,
      });
      // Invalidate org profiles list so members page reflects updated name/title/skills
      await queryClient.invalidateQueries({
        queryKey: [{ _id: "getV1OrganizationsByOrganizationIdProfiles" }],
      });
    },
    onError: (error) => {
      console.error("Mutation failed:", error);
    },
  });
};
